<template>
  <div class="wrap">
    <SpringPage 
    :verse = "verse" 
    :page = "page" 
    :print_verse = "print_verse"
    :goto_choice = "goto_choice" 
    :scroll = "scroll"
    :scroll_click = "scroll_click"
    :share_fun = "share_fun"
    :goto_another = "goto_another"
    :goto_ws = "goto_ws"
    :image_save = "image_save"
    v-if="(date=='3' || date=='4' || date=='5')"
    />

    <SummerPage 
    :verse = "verse" 
    :page = "page" 
    :print_verse = "print_verse"
    :goto_choice = "goto_choice" 
    :scroll = "scroll"
    :scroll_click = "scroll_click"
    :share_fun = "share_fun"
    :goto_another = "goto_another"
    :goto_ws = "goto_ws"
    :image_save = "image_save"
    v-if="(date=='6' || date=='7' || date=='8')"
    />

    <FallPage 
    :verse = "verse" 
    :page = "page" 
    :print_verse = "print_verse"
    :goto_choice = "goto_choice" 
    :scroll = "scroll"
    :scroll_click = "scroll_click"
    :share_fun = "share_fun"
    :goto_another = "goto_another"
    :goto_ws = "goto_ws"
    :image_save = "image_save"
    v-if="(date=='9' || date=='10' || date=='11')"
    />
    
    <WinterPage 
    :verse = "verse" 
    :page = "page" 
    :print_verse = "print_verse"
    :goto_choice = "goto_choice" 
    :scroll = "scroll"
    :scroll_click = "scroll_click"
    :share_fun = "share_fun"
    :goto_another = "goto_another"
    :goto_ws = "goto_ws"
    :image_save = "image_save"
    :date = "date"
    v-if="(date=='12' || date=='1' || date=='2')"
    />
    <NewYearPage
    :verse = "verse" 
    :page = "page" 
    :print_verse = "print_verse"
    :goto_choice = "goto_choice" 
    :scroll = "scroll"
    :scroll_click = "scroll_click"
    :share_fun = "share_fun"
    :goto_another = "goto_another"
    :goto_ws = "goto_ws"
    :image_save = "image_save"
    v-if="(date=='12.28' || date=='12.29' || date=='12.30' || date=='12.31' || date=='1.1' || date=='1.2' || date=='1.3')"
    />

    <Seollal
    :verse = "verse" 
    :page = "page" 
    :print_verse = "print_verse"
    :goto_choice = "goto_choice" 
    :scroll = "scroll"
    :scroll_click = "scroll_click"
    :share_fun = "share_fun"
    :goto_another = "goto_another"
    :goto_ws = "goto_ws"
    :image_save = "image_save"
    v-if="date=='2.13' || date=='2.14' || date=='2.15' || date=='2.16' || date=='2.17' || date=='2.18'"
    />

  </div>
</template>

<script>
import NewYearPage from './pages/NewYearPage.vue'
import WinterPage from './pages/WinterPage.vue'
import verse from './assets/verse/list.json'
import FallPage from './pages/FallPage.vue'
import SpringPage from './pages/SpringPage.vue'
import SummerPage from './pages/SummerPage.vue'
import 'regenerator-runtime/runtime'
import download from 'downloadjs'
import Seollal from './pages/Seollal.vue'

export default {
  data() {
    return {
      verse : verse,
      date : "",
      page : 1,
      scroll : false,
      print_verse:{
        chapter : "",
        verse : []
      }
    }
  },
  components: { NewYearPage, WinterPage, FallPage, SpringPage, SummerPage, Seollal },
  methods: {
    goto_choice(){
      setTimeout(() => {
        this.page=2;
      }, 500);
      setTimeout(() => {
        let max = this.verse['list'].length;
        let idx = Math.floor(Math.random()*(max+1));
        let list=this.verse['list'][idx];
        this.print_verse.chapter=list.chapter;
        this.print_verse.verse=list.verse;
        this.scroll=false;
        this.page=3;
        this.page=3;
      }, 5000);
    },
    scroll_click(){
      this.scroll=!this.scroll;
    },
    share_fun: async function(){
      try {
          await navigator.share({
              title: "말씀뽑기",
              url: "",
          });
          console.log("공유 성공");
      } catch (e) {
          var ans=confirm('url 복사하시겠습니까?');
          if(ans){
              var url = '';
              var textarea = document.createElement("textarea");
              document.body.appendChild(textarea);
              url = location.origin+location.pathname;
              textarea.value = url;
              textarea.select();
              document.execCommand("copy");
              document.body.removeChild(textarea);
          }
      }
    },
    goto_another(){
        window.open('https://wordsquare.org/square-crossroads/assessments');
    },
    goto_ws(){
        window.open('https://wordsquare.org/');
    },
    image_save : async function (){
      let chapter = this.print_verse.chapter
      const el = document.getElementsByClassName('capture_area')[0];
      const canvas = await this.$html2canvas(el);
      const dataURL = canvas.toDataURL('image/png');
      download(dataURL, `축복의 말씀-${chapter}.png`, 'image/png');
    },
  },
  mounted() {
    let month = new Date().getMonth()+1;
    let date = new Date().getDate();
    let mon_date = `${month}.${date}`;
    if((mon_date=='12.28' || mon_date=='12.29' || mon_date=='12.30' || mon_date=='12.31' || mon_date=='1.1' || mon_date == '1.2' || mon_date == '1.3') || (mon_date=='2.13' || mon_date=='2.14' || mon_date=='2.15' || mon_date=='2.16' || mon_date=='2.17' || mon_date=='2.18')){
      this.date=mon_date;
    }else{
      this.date=mon_date.split('.')[0];
    }
    console.log(this.date);
  },
}
</script>
<style lang="css" scoped>
  @import '@/assets/style/app.css';
</style>
